import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ISbRichtext } from '@storyblok/js';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { ReplaceTextPipe } from '../../pipes/replace-text.pipe';
import { StoryblokRichTextPipe } from '../../storyblok-rich-text.pipe';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-faq-list',
  standalone: true,
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss'],
  imports: [
    CommonModule,
    BlockWrapperComponent,
    StoryblokRichTextPipe,
    StoryblokDirective,
    ButtonDirective,
    ReplaceTextPipe,
  ],
})
export class FaqListComponent {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() faqStyle: 'simple' | 'borderedList' = 'simple';
  @Input() faqs: {
    _editable: string;
    question: string;
    answer: ISbRichtext;
  }[];
}
